import _ from 'lodash';
import { getStartCase } from 'src/utils';
import navigator from './navigator';

export enum Tenants {
  ADMIN = 'admin',
  SALES = 'sales',
}

const TenantOptions = Object.values(Tenants).map((value) => ({
  label: value === Tenants.SALES ? _.upperCase(value) : getStartCase(value),
  isHideOnProduction: false,
  value,
}));

const DefaultTenant = Tenants.SALES;

type Tenant = {
  name: string;
};

let _tenant: Tenant = {
  name: '',
};

const setTenant = (tenant?: Tenant) => {
  if (tenant) return (_tenant = tenant);
};

const getTenant = () => _tenant;

const getWebTenant = () => {
  const subDomain = navigator.getSubdomain();
  const isHasSubdomain = Object.values(Tenants).some((item) => item === subDomain);
  const validSubdomain = isHasSubdomain ? subDomain : DefaultTenant;
  return validSubdomain;
};

const changeWebTenant = (tenant: string) => {
  const validSubdomain = getWebTenant();
  if (tenant !== validSubdomain) {
    const nextDomain = tenant === DefaultTenant ? '' : tenant;
    return navigator.jumpToCrossDomain(nextDomain);
  }
};

// ================== Check tenant ==================
const isAdmin = () => _tenant?.name === Tenants.ADMIN;
const isSales = () => _tenant?.name === Tenants.SALES;

export {
  setTenant,
  getTenant,
  isAdmin,
  isSales,
  DefaultTenant,
  changeWebTenant,
  getWebTenant,
  TenantOptions,
};
